import React, { useContext } from 'react';
import { Card, CardHeader, CardBody } from '@progress/kendo-react-layout';
import { ITicketProps } from '../../../../types/Ticket/ITicket';
import { Icon } from '@progress/kendo-react-common';
import { Button } from '@progress/kendo-react-buttons';
import { RevUserContext } from '../../../../context/UserContext';
import { IUserProfile } from '../../../../types/User/IUserProfile';
import { toDigital } from '../../../../utils/utils';
import { Skeleton } from '@progress/kendo-react-indicators';

const TimeLogged: React.FC<ITicketProps> = (ticket) => {
    const profile = useContext<IUserProfile>(RevUserContext)
    const [display, setDisplay] = React.useState(0);
    const values = [{
        header: 'Time Logged',
        total: toDigital(ticket.Actual_Time + ticket.Actual_NonBill_Time),
        billed: toDigital(ticket.Actual_Time ?? 0),
        notBilled: toDigital(ticket.Actual_NonBill_Time ?? 0),
        imageUrl: './images/time_parent.png'
    },
    {
        header: 'Child Time',
        total: toDigital(ticket.Child_Bill_Time + ticket.Child_NonBill_Time),
        billed: toDigital(ticket.Child_Bill_Time ?? 0),
        notBilled: toDigital(ticket.Child_NonBill_Time ?? 0),
        imageUrl: './images/time_child.png'
    },
    {
        header: 'All Time',
        total: toDigital(ticket.Actual_Time + ticket.Actual_NonBill_Time + ticket.Child_Bill_Time + ticket.Child_NonBill_Time),
        billed: toDigital((ticket.Actual_Time ?? 0) + (ticket.Child_Bill_Time ?? 0)),
        notBilled: toDigital((ticket.Actual_NonBill_Time ?? 0) + (ticket.Child_NonBill_Time ?? 0)),
        imageUrl: './images/time_all.png'
    }];
    const currentValues = values[display];

    if (profile?.Features.External_Interface || ticket.Is_Workstream) return null;

    const projectTimeColor = ticket.Project_Available_Time < 0 ? '#A60606' : '';

    return (
        <Card className="time-logged">
            <CardHeader>
                <Icon size='large' name='clock' />{currentValues.header} {!ticket.Is_Loading && currentValues.total}
                {ticket?.Is_Parent ? <Button style={{ backgroundColor: '#c1c1c1' }} imageUrl={currentValues.imageUrl} onClick={() => setDisplay((d) => d > 1 ? 0 : d + 1)} title='Toggle time: Parent / Children / All' /> : <i></i>}
            </CardHeader>
            <CardBody>
                {/* last render: {new Date().toLocaleTimeString()} */}
                {ticket.Is_Loading ? <Skeleton shape="rectangle" style={{ width: '100%', height: '100px', marginTop: '2px' }} /> :
                    <div className='info'>
                        <div className='g'>{profile?.Features.Non_Bill_Time ? 'Billed' : 'Time'}</div><div className='t'>{currentValues.billed}</div>
                        {profile?.Features.Non_Bill_Time && <><div className='g'>Not Billed</div><div className='t'>{currentValues.notBilled}</div></>}
                        {!ticket.Show_Project_Available_Time && <><div className='g'>Remaining</div><div className='t' style={{ color: projectTimeColor }}>{toDigital(ticket.Project_Available_Time, true)}</div></>}
                    </div>}
            </CardBody>
        </Card>
    );
};

export default TimeLogged;